// removed by extract-text-webpack-plugin
module.exports = {"hero":"src-components-Home----background-module---hero---V14Cn","wrapper":"src-components-Home----background-module---wrapper---33Ohn","section":"src-components-Home----background-module---section---3XMp_","section__title":"src-components-Home----background-module---section__title---Clou8","section__intro":"src-components-Home----background-module---section__intro---2iLOM","section--cta":"src-components-Home----background-module---section--cta---3u6TZ","btn":"src-components-Home----background-module---btn---Kmxq2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/background.module.css
// module id = 676
// module chunks = 35783957827783